import {
  getToken,
  getUser,
} from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

//GET
export const getAllCategories = async (filter) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "categories/get_all",
      {
        requester: getUser(),
        token: getToken(),
        ...filter,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error };
  }
};

export const getCategory = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "categories/show/" + id,
      {
        requester: getUser(),
        token: getToken(),
        // category_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error };
  }
};

export const createCategories = async (data, subcategories) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "categories/create",
      {
        requester: getUser(),
        token: getToken(),
        name: data.name,
        // details: data.details,
        // priority: data.priority,
        subname: subcategories.map((sub) => {
          return sub.subcategory_name;
        }),
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error };
  }
};

export const updateCategories = async (data, subcategories) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "categories/update/"+data.id,
      {
        requester: getUser(),
        token: getToken(),
        name: data.name,
        // priority: data.priority,
        subcategory_id: subcategories.map((sub) => {
          return sub.id;
        }),
        subname: subcategories.map((sub) => {
          return sub.subcategory_name;
        }),
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error };
  }
};

export const deleteCategories = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "inventory_groups/delete",
      {
        requester: getUser(),
        token: getToken(),
        inventory_group_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error };
  }
};

export const searchBranch = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "branches/search",
      {
        requester: getUser(),
        token: getToken(),
        no_inventory_group: 1,
        is_franchise: "0,1",
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error };
  }
};
